import React, { useState, useEffect } from "react";
import ChatThreadDialog from "./ChatThreadDialog";

const AssistantChatThreads = ({
  data,
  pagination,
  onPageChange,
  sort,
  onSortChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onApplyFilters,
  onShowSearches,
  hideFilters = false,
  initialSelectedThreadId = null,
  totalInteractions = 0,
}) => {
  const [selectedThread, setSelectedThread] = useState(null);


  useEffect(() => {
    if (initialSelectedThreadId) {
      setSelectedThread({ chat_thread_id: initialSelectedThreadId });
    }
  }, [initialSelectedThreadId]);



  const formatDate = (ts) => new Date(ts).toLocaleString();

  return (
    <div className="p-6 h-full overflow-y-auto">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
        {!hideFilters && <h1 className="text-2xl font-semibold text-gray-800">Assistant Chat Threads</h1>}
        {!hideFilters && (
          <div className="flex flex-wrap gap-2 items-center ml-auto">
            {onShowSearches && (
              <button
                onClick={onShowSearches}
                className="bg-indigo-50 text-indigo-700 hover:bg-indigo-100 font-semibold py-1.5 px-4 rounded transition text-sm border border-indigo-200 mr-2"
              >
                Show Assistant AI Searches
              </button>
            )}
            <input
              type="date"
              value={startDate}
              onChange={(e) => onStartDateChange(e.target.value)}
              className="border rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-indigo-500"
            />
            <span className="text-gray-500">to</span>
            <input
              type="date"
              value={endDate}
              onChange={(e) => onEndDateChange(e.target.value)}
              className="border rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-indigo-500"
            />
            <button
              onClick={onApplyFilters}
              className="px-4 py-1.5 bg-indigo-600 text-white rounded text-sm hover:bg-indigo-700 transition-colors"
            >
              Filter
            </button>
            <select
              value={sort}
              onChange={(e) => onSortChange(e.target.value)}
              className="border rounded px-3 py-1.5 text-sm focus:ring-2 focus:ring-indigo-500 ml-2"
            >
              <option value="latest">Latest</option>
              <option value="oldest">Oldest</option>
            </select>
          </div>
        )}
      </div>

      <div className="flex justify-end px-4 py-2 border-b bg-gray-50 rounded-t-lg">
        <span className="text-sm font-semibold text-gray-700">Total Chat Threads: {pagination?.totalItems?.toLocaleString() || 0} | Total Interactions: {totalInteractions.toLocaleString()}</span>
      </div>

      <div className="bg-white rounded-b-lg shadow-sm border overflow-hidden border-t-0">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Thread ID</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">User Email</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Latest Interaction</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Interactions</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {data.map((thread, idx) => (
                <tr key={idx} className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{thread.chat_thread_id || "N/A"}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{thread.visitor_email || thread.visitor_id || "N/A"}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{formatDate(thread.latest_interaction)}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{thread.interaction_count}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                    <button
                      onClick={() => setSelectedThread(thread)}
                      className="text-indigo-600 hover:text-indigo-900 font-medium"
                    >
                      View Chat
                    </button>
                  </td>
                </tr>
              ))}
              {data.length === 0 && (
                <tr>
                  <td colSpan="5" className="px-6 py-8 text-center text-gray-500">No chat threads found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Pagination controls */}
      {pagination && pagination.totalPages > 1 && (
        <div className="flex justify-center mt-6">
          <div className="flex gap-2 items-center">
            <button
              disabled={pagination.page <= 1}
              onClick={() => onPageChange(pagination.page - 1)}
              className="px-3 py-1 border rounded hover:bg-gray-50 disabled:opacity-50 text-sm"
            >
              Prev
            </button>
            <span className="text-sm text-gray-600">
              Page {pagination.page} of {pagination.totalPages}
            </span>
            <button
              disabled={pagination.page >= pagination.totalPages}
              onClick={() => onPageChange(pagination.page + 1)}
              className="px-3 py-1 border rounded hover:bg-gray-50 disabled:opacity-50 text-sm"
            >
              Next
            </button>
          </div>
        </div>
      )}

      {/* Chat Thread Dialog */}
      <ChatThreadDialog 
        open={!!selectedThread} 
        threadId={selectedThread?.chat_thread_id} 
        onClose={() => setSelectedThread(null)} 
        initialThread={selectedThread} 
      />
    </div>
  );
};

export default AssistantChatThreads;
